"use strict";
var $a5fd07fa01589658$exports = {};
"use strict";
class $a5fd07fa01589658$var$Game {
    constructor(initialState){
        const defaultState = [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        this.initialState = initialState ? initialState.map((row)=>[
                ...row
            ]) : defaultState;
        this.nextId = 1;
        this.tiles = [];
        this.state = [
            [
                null,
                null,
                null,
                null
            ],
            [
                null,
                null,
                null,
                null
            ],
            [
                null,
                null,
                null,
                null
            ],
            [
                null,
                null,
                null,
                null
            ]
        ];
        for(let r = 0; r < 4; r++){
            for(let c = 0; c < 4; c++)if (this.initialState[r][c] !== 0) {
                const tile = {
                    id: this.nextId++,
                    value: this.initialState[r][c],
                    r: r,
                    c: c
                };
                this.state[r][c] = tile;
                this.tiles.push(tile);
            }
        }
        this.score = 0;
        this.status = "idle";
    }
    getScore() {
        return this.score;
    }
    getTiles() {
        return this.tiles;
    }
    getState() {
        const arr = [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        for(let r = 0; r < 4; r++)for(let c = 0; c < 4; c++){
            const tile = this.state[r][c];
            if (tile) arr[r][c] = tile.value;
        }
        return arr;
    }
    getStatus() {
        return this.status;
    }
    start() {
        this.status = "playing";
        this.addRandomCell();
        this.addRandomCell();
        this.checkEndGame();
    }
    restart() {
        this.nextId = 1;
        this.tiles = [];
        this.state = [
            [
                null,
                null,
                null,
                null
            ],
            [
                null,
                null,
                null,
                null
            ],
            [
                null,
                null,
                null,
                null
            ],
            [
                null,
                null,
                null,
                null
            ]
        ];
        for(let r = 0; r < 4; r++){
            for(let c = 0; c < 4; c++)if (this.initialState[r][c] !== 0) {
                const tile = {
                    id: this.nextId++,
                    value: this.initialState[r][c],
                    r: r,
                    c: c
                };
                this.state[r][c] = tile;
                this.tiles.push(tile);
            }
        }
        this.score = 0;
        this.status = "idle";
    }
    addRandomCell() {
        const emptyCells = [];
        for(let r = 0; r < 4; r++){
            for(let c = 0; c < 4; c++)if (!this.state[r][c]) emptyCells.push({
                r: r,
                c: c
            });
        }
        if (emptyCells.length > 0) {
            const { r: r, c: c } = emptyCells[Math.floor(Math.random() * emptyCells.length)];
            const tile = {
                id: this.nextId++,
                value: Math.random() < 0.9 ? 2 : 4,
                r: r,
                c: c,
                isNew: true
            };
            this.state[r][c] = tile;
            this.tiles.push(tile);
        }
    }
    checkEndGame() {
        let has2048 = false;
        let hasEmpty = false;
        let hasMoves = false;
        const arr = this.getState();
        for(let r = 0; r < 4; r++)for(let c = 0; c < 4; c++){
            if (arr[r][c] >= 2048) has2048 = true;
            if (arr[r][c] === 0) hasEmpty = true;
            if (c < 3 && arr[r][c] === arr[r][c + 1]) hasMoves = true;
            if (r < 3 && arr[r][c] === arr[r + 1][c]) hasMoves = true;
        }
        if (has2048) this.status = "win";
        else if (!hasEmpty && !hasMoves) this.status = "lose";
    }
    move(direction) {
        if (this.status !== "playing") return;
        this.tiles.forEach((t)=>{
            t.isNew = false;
            t.isMerged = false;
        });
        let moved = false;
        let addedScore = 0;
        for(let i = 0; i < 4; i++){
            const lineTiles = [];
            const getCoords = (lineIndex, cellIndex)=>{
                switch(direction){
                    case "left":
                        return {
                            r: lineIndex,
                            c: cellIndex
                        };
                    case "right":
                        return {
                            r: lineIndex,
                            c: 3 - cellIndex
                        };
                    case "up":
                        return {
                            r: cellIndex,
                            c: lineIndex
                        };
                    case "down":
                        return {
                            r: 3 - cellIndex,
                            c: lineIndex
                        };
                    default:
                        return {
                            r: 0,
                            c: 0
                        };
                }
            };
            for(let j = 0; j < 4; j++){
                const { r: r, c: c } = getCoords(i, j);
                if (this.state[r][c] !== null) lineTiles.push(this.state[r][c]);
            }
            const newLine = [];
            let k = 0;
            while(k < lineTiles.length)if (k + 1 < lineTiles.length && lineTiles[k].value === lineTiles[k + 1].value) {
                lineTiles[k].value *= 2;
                lineTiles[k].isMerged = true;
                this.tiles = this.tiles.filter((t)=>t !== lineTiles[k + 1]);
                newLine.push(lineTiles[k]);
                addedScore += lineTiles[k].value;
                k += 2;
            } else {
                newLine.push(lineTiles[k]);
                k++;
            }
            while(newLine.length < 4)newLine.push(null);
            for(let j = 0; j < 4; j++){
                const { r: r, c: c } = getCoords(i, j);
                const item = newLine[j];
                if (this.state[r][c] !== item) moved = true;
                this.state[r][c] = item;
                if (item) {
                    item.r = r;
                    item.c = c;
                }
            }
        }
        if (moved) {
            this.score += addedScore;
            this.addRandomCell();
            this.checkEndGame();
        }
    }
    moveLeft() {
        this.move("left");
    }
    moveRight() {
        this.move("right");
    }
    moveUp() {
        this.move("up");
    }
    moveDown() {
        this.move("down");
    }
}
$a5fd07fa01589658$exports = $a5fd07fa01589658$var$Game;


const $09e991522ca7e64e$var$game = new $a5fd07fa01589658$exports();
const $09e991522ca7e64e$var$startButton = document.querySelector(".button.start");
const $09e991522ca7e64e$var$scoreEl = document.querySelector(".game-score");
const $09e991522ca7e64e$var$msgStart = document.querySelector(".message-start");
const $09e991522ca7e64e$var$msgWin = document.querySelector(".message-win");
const $09e991522ca7e64e$var$msgLose = document.querySelector(".message-lose");
let $09e991522ca7e64e$var$started = false;
let $09e991522ca7e64e$var$firstMoveDone = false;
function $09e991522ca7e64e$var$render() {
    const gameStatus = $09e991522ca7e64e$var$game.getStatus();
    const score = $09e991522ca7e64e$var$game.getScore();
    $09e991522ca7e64e$var$scoreEl.textContent = score;
    const tilesEl = document.querySelector(".tiles-container");
    const renderedTiles = Array.from(tilesEl.children);
    const activeTiles = $09e991522ca7e64e$var$game.getTiles();
    activeTiles.forEach((tile)=>{
        let tileEl = document.getElementById(`tile-${tile.id}`);
        if (!tileEl) {
            tileEl = document.createElement("div");
            tileEl.id = `tile-${tile.id}`;
            tilesEl.appendChild(tileEl);
        }
        tileEl.className = `tile tile--${tile.value} field-cell--${tile.value}`;
        if (tile.isNew) tileEl.classList.add("is-new");
        else tileEl.classList.remove("is-new");
        if (tile.isMerged) tileEl.classList.add("is-merged");
        else tileEl.classList.remove("is-merged");
        tileEl.textContent = tile.value;
        tileEl.style.setProperty("--r", tile.r);
        tileEl.style.setProperty("--c", tile.c);
    });
    const activeIds = new Set(activeTiles.map((t)=>`tile-${t.id}`));
    renderedTiles.forEach((el)=>{
        if (!activeIds.has(el.id)) el.remove();
    });
    if (gameStatus === "playing") {
        $09e991522ca7e64e$var$msgStart.classList.add("hidden");
        $09e991522ca7e64e$var$msgWin.classList.add("hidden");
        $09e991522ca7e64e$var$msgLose.classList.add("hidden");
    } else if (gameStatus === "win") {
        $09e991522ca7e64e$var$msgWin.classList.remove("hidden");
        $09e991522ca7e64e$var$msgStart.classList.add("hidden");
        $09e991522ca7e64e$var$msgLose.classList.add("hidden");
    } else if (gameStatus === "lose") {
        $09e991522ca7e64e$var$msgLose.classList.remove("hidden");
        $09e991522ca7e64e$var$msgStart.classList.add("hidden");
        $09e991522ca7e64e$var$msgWin.classList.add("hidden");
    } else if (gameStatus === "idle") {
        $09e991522ca7e64e$var$msgStart.classList.remove("hidden");
        $09e991522ca7e64e$var$msgWin.classList.add("hidden");
        $09e991522ca7e64e$var$msgLose.classList.add("hidden");
    }
}
$09e991522ca7e64e$var$startButton.addEventListener("click", ()=>{
    if (!$09e991522ca7e64e$var$started) {
        $09e991522ca7e64e$var$game.start();
        $09e991522ca7e64e$var$started = true;
        $09e991522ca7e64e$var$render();
    } else {
        $09e991522ca7e64e$var$game.restart();
        $09e991522ca7e64e$var$startButton.textContent = "Start";
        $09e991522ca7e64e$var$startButton.classList.remove("restart");
        $09e991522ca7e64e$var$startButton.classList.add("start");
        $09e991522ca7e64e$var$started = false;
        $09e991522ca7e64e$var$firstMoveDone = false;
        $09e991522ca7e64e$var$render();
    }
});
document.addEventListener("keydown", (e)=>{
    if ($09e991522ca7e64e$var$game.getStatus() !== "playing") return;
    const oldState = JSON.stringify($09e991522ca7e64e$var$game.getState());
    if (e.key === "ArrowUp" || e.key.toLowerCase() === "w") $09e991522ca7e64e$var$game.moveUp();
    if (e.key === "ArrowDown" || e.key.toLowerCase() === "s") $09e991522ca7e64e$var$game.moveDown();
    if (e.key === "ArrowLeft" || e.key.toLowerCase() === "a") $09e991522ca7e64e$var$game.moveLeft();
    if (e.key === "ArrowRight" || e.key.toLowerCase() === "d") $09e991522ca7e64e$var$game.moveRight();
    const newState = JSON.stringify($09e991522ca7e64e$var$game.getState());
    if (oldState !== newState && !$09e991522ca7e64e$var$firstMoveDone) {
        $09e991522ca7e64e$var$firstMoveDone = true;
        $09e991522ca7e64e$var$startButton.textContent = "Restart";
        $09e991522ca7e64e$var$startButton.classList.remove("start");
        $09e991522ca7e64e$var$startButton.classList.add("restart");
    }
    $09e991522ca7e64e$var$render();
});
$09e991522ca7e64e$var$render();


//# sourceMappingURL=2048-game.88e153e2.js.map
